<template>
  <div id="cerrar" class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="images/logofo2.png"
          height="25"
          alt="Factura On Line Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="images/logofo.png"
          width="30"
          height="30"
          alt="Factura On Line Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none ml-auto d-SM-none">
        <b-img height="30" :src="user.cuenta.uriImagen" :alt="user.username" />
        <h4 class="ml-2">{{ user.cuenta.razonSocial }}</h4>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
         <template v-if="cargando">
          <i class="fa fa-spin fa-spinner mr-2" />Verificando pagos pendientes
        </template>
        <template v-else>
          <i v-if="porpagar === 0"  @click="infoNotificacion()" class="fa fa-2x fa-smile text-success cursor" />
          <i v-else @click="infoNotificacion()" class="fas fa-2x fa-frown text-warning cursor" />
        </template>
       <!-- NOTIFIACIONES -->
          <b-button @click="abrirLista()" variant="ligth">
            <template v-if="cantidadNoti > 0">
              <i class="bell fa fa-2x fa-bell"/>
              <b-badge pill variant="danger" style="position: relative; top: -10px; z-index: 10">
                <span>{{ cantidadNoti }}</span> <!-- ingresar otra variable -->
              </b-badge>
            </template>
            <template v-else>
              <i class="fa fa-2x fa-bell"/>
            </template> 
            <!-- LISTA NOTIFICACION -->
          <b-list-group id="eventoClic" style="visibility:hidden;background-color:white" class="posicionLista mt-3">
            <h1 align="left" class="notificacionList">Notificaciones</h1>
              <b-list-group-item v-for="(item, index) in informacionNotificacion" style="" href="#" class="flex-column align-items-start datosLista" :key="index" @click="notifiacionEstado(item.idNotification,item.estado)">
                <div class="d-flex w-100 justify-content-between">
                   <template v-if="item.estado == 0">
                    <h5><b>El usuario {{item.idEmisor}}</b></h5>
                  </template>
                  <template v-else>
                    <h5>El usuario {{item.idEmisor}}</h5>
                  </template>
                  <template v-if="item.estado == 0">
                    <h5><b>{{item.created_at | moment('DD/MM/YYYY')}}</b></h5> 
                  </template>
                  <template v-else>
                    <h5>{{item.created_at | moment('DD/MM/YYYY')}}</h5>
                  </template>
                  <!-- <i v-if="item.estado == 0" class="fa fa-circle text-primary"></i> -->
                </div>
                <div class="d-flex w-100 justify-content-between">
                  <template v-if="item.estado == 0">
                    <h5 align="left"><b>{{item.notificacion}} </b></h5>
                    <i v-if="item.estado == 0" class="fa fa-circle text-primary"></i>
                  </template>
                  <template v-else>
                    <h5 align="left">{{item.notificacion}}</h5>
                  </template>
                </div>
              </b-list-group-item>
          </b-list-group>
          <!-- FIN LISTA NOTIFICACION -->
          </b-button>
          <!-- FIN NOTIFICACIONES -->
          <b-button @click="abrirListaPaginas()" variant="outline-secondary" class="mr-5 botonPaginas"><i class="fa fa-th" style="color:black" aria-hidden="true"></i>
            <b-list-group id="eventoClicPaginas" class="posicionListaPaginas">
              <b-list-group-item style="color:black">
                <b-row>
                  <b-col cols="4">
                    <div>
                      <div class="fondo">
                        <a href="https://wenet.pe/" target="_blank"><img src="images/Wenet.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Wenet
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div>
                      <div class="fondo">
                        <a href="https://menu.facturaonline.pe/#/login" target="_blank"><img src="images/Menu.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Menu
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div>
                      <div class="fondo">
                        <a href="https://intranet.facturaonline.pe/login" target="_blank"><img src="images/Intranet.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Intranet
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <div>
                      <div class="fondo">
                        <a href="https://tienda.facturaonline.pe/login" target="_blank"><img src="images/Tienda.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Tienda
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div>
                      <div class="fondo">
                        <a href="https://parking.facturaonline.pe/" target="_blank"><img src="images/Parking.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Parking
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div>
                      <div class="fondo">
                        <a  href="https://libroreclamaciones.facturaonline.pe/" target="_blank"><img src="images/LibroReclamaciones.png" class="imagen"></a>
                        <div class="nombreImagen">
                          Lib. Reclam.
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-button>
        <div>
          <b-button @click="soporteT" variant="primary" target="_blank"
            >Soporte <i class="fas fa-tools"></i
          ></b-button>
          <b-modal v-model="soporte" title="Soporte">
            <b-card>
              Por favor comuníquese con nuestra área de soporte como celular o
              whatsapp <i class="fab text-success fa-whatsapp-square"></i> :
              <br />
              <hr />
              <b> Soporte para FacturaOnline:</b> <br />
              Anabel Carrasco : 948489822 <br />
              Carol Gonzales : 977340146 <br />
              <hr />
              <b>Facturación y Cobranzas</b> <br />
              972000222 <br />
              920822008 <br />
              995570648 <br />
              920014965 <br />
              cobranzas@telemovilperu.com<br />
              <div class="openUrl" @click="urlOpen()">Formas de Pago</div>
              <hr/>
              <b>Facturación y Renovaciones</b> <br />
              969500630
              <hr>
              <b>Soporte para Telemovil Contable:</b> <br />
              Email: soporte@telemovilperu.com <br><br>
             <b> Soporte Factura Online</b><br>
              <a href="https://soporte.facturaonline.pe/" target="_blank">Generar Ticket</a>
            </b-card>
          </b-modal>
        </div>
        <b-nav-item class="mr-4">
          <DefaultHeaderDropdownAccnt />
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="listanav" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <br />
        <!-- <Breadcrumb :list="list"/> -->
        <div class="container-fluid">
          <router-view />
          <div class="position">
            <botonWhatsApp/>
          </div>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <b-container text-center fluid>
        <b-row>
          <b-col cols="2" class="p-0" align-self="center">
            <div class="ml-0 ">
              <a href="https://facturaonline.pe" target="_blank"
                >Factura On Line</a
              >
              <span class="ml-1">&copy; 2018 Telemovil Data.</span>
            </div>
          </b-col >
          <b-col cols="6"  align-self="center">
            
              <p class="tmo marquee soportetecnicoestilos">
                {{ cadenamensajes }}
              </p>
           
          </b-col>
          <b-col cols="2" class="p-0" align-self="center">
             <librorec  />
             </b-col>
          <b-col cols="2"  class="p-0" align-self="center">
            <!-- <span class="mr-2">APP MOVIL: </span> -->
            <a
              class="mr-1"
              href="https://play.google.com/store/apps/details?id=com.facturaonline.Factura_Online_2"
              target="_blank"
              ><img
                src="images/app.png"
                alt="APP Movil FacturaOnline"
                height="56"
            /></a>
          </b-col>
        </b-row>
      </b-container>

     
    </TheFooter>
  </div>
</template>

<script>
import axios from "axios";
import { initnav } from "@/services/funciones";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import librorec from "./botonReclamos";
import botonWhatsApp from "./botonWhatsApp";
export default {
  name: "DefaultContainer",
  components: {
    //  AsideToggler,
    AppHeader,
    AppSidebar,
    //  AppAside,
    TheFooter,
    //  Breadcrumb,
    // DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    librorec,
    botonWhatsApp
    // MarqueeText
  },
  mounted() {
    this.getUserData();
    this.notificacion();
    this.getMensajes();
    this.getNav();
    this.listaNotificacion();
    // this.ServicioRuc();
  },
  data() {
    return {
      listanav: [],
      mensajes: [],
      cadenamensajes: "",
      cargando: false,
      user: {
        cuenta: {
          razonsocial: "",
        },
      },
      token: "",
      porpagar: 0,
      cod: "wenet",
      validarServicio: [],
      servicio: false,
      modalServicio: false,
      soporte: false,
      informacionNotificacion:[],
      mostrarLista:false,
      mostrarListaPaginas:false,
      cantidadNoti:0
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    getNav: function () {
      this.listanav = [];
      this.listanav = initnav(
        this.$store.getters.getPermisos,
        this.$store.getters.userDataRetencion,
        this.$store.getters.userData.idEmisor
      );
    },
    getMensajes: function () {
      let cad = "";
      this.mensajes = this.$store.getters.userMensajes;
      for (let i = 0; i < this.mensajes.length; i++) {
        cad += this.mensajes[i].mensaje + " / ";
      }
      this.cadenamensajes = cad;
    },
    notificacion: function () {
      this.cargando = true;
      axios
        .post(
          process.env.VUE_APP_API_URL +
            "documentoscredito/notificacion/porpagar",
          {
            token: this.$store.getters.userToken,
          }
        )
        .then((response) => {
          this.cargando = false;
          this.porpagar = response.data.response;
        })
        .catch((error) => {
          this.cargando = false;
          console.log(error);
        });
    },
    infoNotificacion: function () {
      let icono = "";
      this.porpagar === 0 ? (icono = "success") : (icono = "warning");
      this.$swal({
        title: "Pagos Pendientes",
        text: "Usted tiene " + this.porpagar + " facturas pendientes de pago",
        icon: icono,
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        console.log(willDelete);
      });
    },
    getUserData: function () {
      this.user = this.$store.getters.userData;
      this.token = this.$store.getters.userToken;
    },
   
    soporteT() {
      this.soporte = true;
    },
    urlOpen(){
      window.open('http://telemovildata.com/formadepago', '_blank');
    },
    listaNotificacion: function () {
      axios.post(process.env.VUE_APP_API_URL + "notificacion/listar",{
        token: this.$store.getters.userToken,
      })
      .then((response) => {
        this.informacionNotificacion = response.data.data,
        this.estadoLista(response.data.data)
        })
      .catch((error) => {
        console.log(error);
      });
    },
    estadoLista(array){
      let cantidad
      let arrayDatos = []
      array.forEach(function(element){
        if(element.estado == 0){
          arrayDatos.push(Object.values(element.estado)) 
          cantidad = arrayDatos.length
        }
      });
      this.cantidadNoti = cantidad
    },
    notifiacionEstado(idNotifiacion,estado){
      axios.post(process.env.VUE_APP_API_URL + "notificacion/estado",{
        token: this.$store.getters.userToken,
        id:String(idNotifiacion),
        estado: "1"
      })
      .then((response) => {
        console.log(response.data.data)
        })
      .catch((error) => {
        console.log(error);
      });
    },
    abrirLista(){
      if(this.mostrarLista==false ){
          document.getElementById('eventoClic').style.visibility="visible";
          this.mostrarLista=true;
      }else{
          document.getElementById("eventoClic").style.visibility="hidden";
          this.mostrarLista=false;
    }
      window.addEventListener("click", function(event){
      if(event.target !=true){
        document.getElementById('eventoClic').style.visibility="hidden"
        this.mostrarLista = true;
      }},true);
    },
    abrirListaPaginas(){
      if(this.mostrarListaPaginas==false ){
          document.getElementById('eventoClicPaginas').style.visibility="visible";
          this.mostrarListaPaginas=true;
      }else{
          document.getElementById("eventoClicPaginas").style.visibility="hidden";
          this.mostrarListaPaginas=false;
    }
      window.addEventListener("click", function(event){
      if(event.target !=true){
        document.getElementById('eventoClicPaginas').style.visibility="hidden"
        this.mostrarListaPaginas = true;
      }},true);
    }
  },
};
</script>

<style>
.soportetecnicoestilos {
  color: red;
}
</style>

<style>
.marquee {
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  animation: marquee 15s linear infinite;
}

.marquee:hover {
  animation-play-state: paused;
}

/* Make it move */
@keyframes marquee {
  0% {
    text-indent: 27.5em;
  }
  100% {
    text-indent: -20em;
  }
}

/* Make it pretty */
.tmo {
  padding-left: 1.5em;
  position: relative;
  font: 16px "Segoe UI", Tahoma, Helvetica, Sans-Serif;
}

/* ::before was :before before ::before was ::before - kthx */
.tmo:before,
.tmo::before {
  z-index: 2;
  content: "";
  position: absolute;
  top: -1em;
  left: -1em;
  width: 0.5em;
  height: 0.5em;
}

.toggle {
  display: block;
  margin: 2em auto;
}
.openUrl{
  color:deepskyblue;
  cursor: pointer;
}
.cursor{
  cursor: pointer;
}

</style>
<style scoped>
.posicionListaPaginas::-webkit-scrollbar {
    -webkit-appearance: none;
}

.posicionListaPaginas::-webkit-scrollbar:vertical {
    width:10px;
}

.posicionListaPaginas::-webkit-scrollbar-button:increment,.contenedor::-webkit-scrollbar-button {
    display: none;
} 

.posicionListaPaginas::-webkit-scrollbar:horizontal {
    height: 10px;
}

.posicionListaPaginas::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.posicionListaPaginas::-webkit-scrollbar-track {
    border-radius: 10px;  
}
.botonPaginas{
  border-radius:18px;
  border:none
}
.imagen{
  width: 80%;
  height:70%;
  margin-left: 12%;
  margin-top: 5px;
}
.fondo{
  /* background-color:skyblue; */
  width:100%;
  height:90px;
  border-radius:9px
}
.fondo:hover{
  background-color: #e8f0fe;
}
.nombreImagen{
  text-align:center;
  margin-bottom: 20px;
}
.posicionListaPaginas {
    visibility:hidden;
    z-index: 1000;
    position: absolute;
    max-height: 700px !important;
    overflow-y: scroll;
    width: 340px;
}
/* .posicionLista::-webkit-scrollbar {
    -webkit-appearance: none;
}

.posicionLista::-webkit-scrollbar:vertical {
    width:10px;
}

.posicionLista::-webkit-scrollbar-button:increment,.contenedor::-webkit-scrollbar-button {
    display: none;
} 

.posicionLista::-webkit-scrollbar:horizontal {
    height: 10px;
}

.posicionLista::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.posicionLista::-webkit-scrollbar-track {
    border-radius: 10px;  
} */
  .posicionLista {
    z-index: 1000;
    position: absolute;
    max-height: 700px !important;
    overflow-y: scroll;
    width: 360px;
    border-radius: 4px;
    
}
.datosLista {
    font-size: smaller;
    padding: 10px
  }
  .bell{
  -webkit-animation: ring 4s .7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s .7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s .7s ease-in-out infinite;
  transform-origin: 50% 4px;  
  }
  @-webkit-keyframes ring {
  0% { -webkit-transform: rotateZ(0); }
  1% { -webkit-transform: rotateZ(30deg); }
  3% { -webkit-transform: rotateZ(-28deg); }
  5% { -webkit-transform: rotateZ(34deg); }
  7% { -webkit-transform: rotateZ(-32deg); }
  9% { -webkit-transform: rotateZ(30deg); }
  11% { -webkit-transform: rotateZ(-28deg); }
  13% { -webkit-transform: rotateZ(26deg); }
  15% { -webkit-transform: rotateZ(-24deg); }
  17% { -webkit-transform: rotateZ(22deg); }
  19% { -webkit-transform: rotateZ(-20deg); }
  21% { -webkit-transform: rotateZ(18deg); }
  23% { -webkit-transform: rotateZ(-16deg); }
  25% { -webkit-transform: rotateZ(14deg); }
  27% { -webkit-transform: rotateZ(-12deg); }
  29% { -webkit-transform: rotateZ(10deg); }
  31% { -webkit-transform: rotateZ(-8deg); }
  33% { -webkit-transform: rotateZ(6deg); }
  35% { -webkit-transform: rotateZ(-4deg); }
  37% { -webkit-transform: rotateZ(2deg); }
  39% { -webkit-transform: rotateZ(-1deg); }
  41% { -webkit-transform: rotateZ(1deg); }

  43% { -webkit-transform: rotateZ(0); }
  100% { -webkit-transform: rotateZ(0); }
  }
  @-moz-keyframes ring {
  0% { -moz-transform: rotate(0); }
  1% { -moz-transform: rotate(30deg); }
  3% { -moz-transform: rotate(-28deg); }
  5% { -moz-transform: rotate(34deg); }
  7% { -moz-transform: rotate(-32deg); }
  9% { -moz-transform: rotate(30deg); }
  11% { -moz-transform: rotate(-28deg); }
  13% { -moz-transform: rotate(26deg); }
  15% { -moz-transform: rotate(-24deg); }
  17% { -moz-transform: rotate(22deg); }
  19% { -moz-transform: rotate(-20deg); }
  21% { -moz-transform: rotate(18deg); }
  23% { -moz-transform: rotate(-16deg); }
  25% { -moz-transform: rotate(14deg); }
  27% { -moz-transform: rotate(-12deg); }
  29% { -moz-transform: rotate(10deg); }
  31% { -moz-transform: rotate(-8deg); }
  33% { -moz-transform: rotate(6deg); }
  35% { -moz-transform: rotate(-4deg); }
  37% { -moz-transform: rotate(2deg); }
  39% { -moz-transform: rotate(-1deg); }
  41% { -moz-transform: rotate(1deg); }

  43% { -moz-transform: rotate(0); }
  100% { -moz-transform: rotate(0); }
  }
  @keyframes ring {
  0% { transform: rotate(0); }
  1% { transform: rotate(30deg); }
  3% { transform: rotate(-28deg); }
  5% { transform: rotate(34deg); }
  7% { transform: rotate(-32deg); }
  9% { transform: rotate(30deg); }
  11% { transform: rotate(-28deg); }
  13% { transform: rotate(26deg); }
  15% { transform: rotate(-24deg); }
  17% { transform: rotate(22deg); }
  19% { transform: rotate(-20deg); }
  21% { transform: rotate(18deg); }
  23% { transform: rotate(-16deg); }
  25% { transform: rotate(14deg); }
  27% { transform: rotate(-12deg); }
  29% { transform: rotate(10deg); }
  31% { transform: rotate(-8deg); }
  33% { transform: rotate(6deg); }
  35% { transform: rotate(-4deg); }
  37% { transform: rotate(2deg); }
  39% { transform: rotate(-1deg); }
  41% { transform: rotate(1deg); }

  43% { transform: rotate(0); }
  100% { transform: rotate(0); }
}
.position{
  position: fixed;
  bottom: 60px;
  right: 10px;
}
.notificacionList{
  padding-top: 2px;
  padding-left: 10px;
  font-size: 25px;
  font-family: Helvetica, Arial, sans-serif;;
}
</style>
